import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Sidebar from '../../components/SideBar';
import NavBar from '../../components/NavBarSearchSong';
import Settings from '../../assets/Settings.png';
import RoundButton from '../../components/RoundButton';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import '../CustomerDetails/CustomerDetails.scss';
import { _showAlert, formatDateToDisplay, getShortNamesOfWeekDays, getSchedulesFromPlaylist } from '../../utils';
import SortIndicator from '../../components/SortIndicator';
import PlaylistActionIcon from '../../components/PlaylistManagement/PlaylistActionIcon';
import PlaylistCopySongsDialog from '../../components/PlaylistManagement/PlaylistCopySongsDialog';
import EditPlaylistSecondery from '../EditPlaylistSecondery';
import Popup from '../../components/Popup';
import { fetcher } from '../../utils/axios';

const useStyles = makeStyles({
  table: {
    maxHeight: '90vh',
    borderRadius: 30,
  },
});

function CustomerDetails(props) {
  const classes = useStyles();
  const playlistAndScheduler = useSelector((state) => state.getCustomerPlaylist.result);
  const dispatch = useDispatch();
  const [selectedCustomer, setSelectedCustomer] = useState({});
  const [previewPlaylist, setPreviewPlaylist] = useState(null);
  const [previewIndex, setPreviewIndex] = useState(0);
  const [copyDialogPlaylist, setCopyDialogPlaylist] = useState(null);
  const [editingPlaylist, setEditingPlaylist] = useState(null);
  const [loadingPlaylistId, setLoadingPlaylistId] = useState(null);
  const isAdmin = JSON.parse(sessionStorage.getItem('authData') || '{}')?.user?.userRole === 1;

  // Sorting states
  const [playlistSortConfig, setPlaylistSortConfig] = useState({ key: null, direction: 'asc' });
  const [scheduleSortConfig, setScheduleSortConfig] = useState({ key: null, direction: 'asc' });

  const handleSort = (key, sortConfig, setSortConfig) => {
    let direction = 'desc';
    let newKey = key;

    if (sortConfig.key === key) {
      if (sortConfig.direction === 'desc') {
        direction = 'asc';
      } else {
        newKey = null;
      }
    }

    setSortConfig({ key: newKey, direction });
  };

  const sortData = (data, sortConfig) => {
    if (!sortConfig.key || !Array.isArray(data)) return data;

    return [...data].sort((a, b) => {
      const valueA = (a[sortConfig.key] || '').toString();
      const valueB = (b[sortConfig.key] || '').toString();

      return sortConfig.direction === 'asc' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
    });
  };

  useEffect(() => {
    if (props?.history?.location?.state) {
      setSelectedCustomer(props.history.location.state);
    }
  }, [props.history]);

  useEffect(() => {
    if (selectedCustomer.id) {
      dispatch({ type: 'GET_CUSTOMER_PLAYLIST', payload: { customerId: selectedCustomer.id } });
    }
  }, [selectedCustomer]);

  const handleEditCustomerPlaylist = () => {
    props.history.push({
      pathname: '/edit-customer-playlists',
      state: selectedCustomer,
    });
  };

  const handleEditCustomerScheduler = () => {
    props.history.push({
      pathname: '/edit-customer-scheduler',
      state: selectedCustomer,
    });
  };

  const refreshCustomerPlaylists = () => {
    if (selectedCustomer.id) dispatch({ type: 'GET_CUSTOMER_PLAYLIST', payload: { customerId: selectedCustomer.id } });
  };

  const openPlaylistAction = async (playlistId, action) => {
    if (loadingPlaylistId) return;
    setLoadingPlaylistId(playlistId);
    try {
      const playlists = await fetcher('/playlists/');
      const playlist = playlists.find((item) => item.id === playlistId);
      if (!playlist) throw new Error('Playlist not found');
      if (action === 'listen') {
        if (!playlist.songs?.length) {
          _showAlert('This playlist has no songs to play', 'error');
        } else {
          setPreviewPlaylist(playlist);
          setPreviewIndex(0);
        }
      } else if (action === 'copy') {
        setCopyDialogPlaylist(playlist);
      } else if (action === 'edit') {
        setEditingPlaylist(playlist);
      }
    } catch (error) {
      _showAlert('Could not load this playlist. Please try again.', 'error');
    } finally {
      setLoadingPlaylistId(null);
    }
  };

  const playlistActions = (playlistId, name, scheduled = false) => {
    const displayName = name || 'playlist';
    return <div className="customer-details-actions">
      <PlaylistActionIcon kind="listen" label={`Listen to ${displayName}`} onClick={() => openPlaylistAction(playlistId, 'listen')} disabled={!!loadingPlaylistId} />
      {!scheduled && <PlaylistActionIcon kind="copy" label={`Copy songs from ${displayName}`} onClick={() => openPlaylistAction(playlistId, 'copy')} disabled={!!loadingPlaylistId} />}
      <PlaylistActionIcon kind="edit" label={`Edit ${displayName}`} onClick={() => openPlaylistAction(playlistId, 'edit')} disabled={!!loadingPlaylistId} />
      {scheduled && isAdmin && <PlaylistActionIcon kind="schedule" label={`Manage schedule for ${displayName}`} onClick={handleEditCustomerScheduler} />}
    </div>;
  };

  const getCustomerName = (customer) => {
    if (customer.name) {
      return customer.name;
    } else {
      let name = '';
      name = customer.firstname || '';
      name = name + ' ' + customer.lastname || '';
      return name || 'N/A';
    }
  };

  return (
    <div className="main">
      <div className="sidebar">
        <Sidebar />
      </div>
      <div className="leftPortion">
        <NavBar
          data="All Customers" icon={Settings} currentRouteName="Customers" breadcrumbsPath="Customers Details"
          showPlayer={true}
          currentSong={previewPlaylist?.songs?.[previewIndex] || null}
          hasNextSong={previewIndex < (previewPlaylist?.songs?.length || 0) - 1}
          onNextSong={() => setPreviewIndex((index) => index + 1)}
          hasPrevSong={previewIndex > 0}
          onPrevSong={() => setPreviewIndex((index) => index - 1)}
          onClosePlayer={() => setPreviewPlaylist(null)}
        />
        <div className="content">
          <div className="warp_edit_row">
            <div className="editRow">
              <div className="wrap_edit">
                <p>Edit:</p>
                <RoundButton className="disabled-button" handleClick={handleEditCustomerPlaylist} btnText="Playlist" />
                <RoundButton className="disabled-button" handleClick={handleEditCustomerScheduler} btnText="Scheduler" />
              </div>
            </div>
          </div>

          <TableContainer className="tbl_wraper" component={Paper}>
            <Table className={classes.table} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Customer Name</TableCell>
                  <TableCell>Royalty Type</TableCell>
                  <TableCell>Business Name</TableCell>
                  <TableCell>Address</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Created At</TableCell>
                  <TableCell>Connection</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>{getCustomerName(selectedCustomer)}</TableCell>
                  <TableCell>{selectedCustomer.royalty_only ? 'Royalty' : 'Free (UnRoyalty)'}</TableCell>
                  <TableCell>{selectedCustomer.business_name || 'N/A'}</TableCell>
                  <TableCell>{selectedCustomer.address || 'N/A'}</TableCell>
                  <TableCell>{selectedCustomer.email}</TableCell>
                  <TableCell>{formatDateToDisplay(selectedCustomer.createdAt)}</TableCell>
                  <TableCell>
                    <span className="gray_circle"></span>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          <div className="wrap_tbl playlist-scheduler-table">
            <TableContainer className="tbl_wraper result_tbl" component={Paper}>
              <Table className={classes.table} stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <TableCell className="table_font">Result</TableCell>
                    <TableCell
                      onClick={() => handleSort('name', playlistSortConfig, setPlaylistSortConfig)}
                      style={{ cursor: 'pointer', userSelect: 'none' }}
                    >
                      Playlist<SortIndicator sortConfig={playlistSortConfig} columnKey="name" />
                    </TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Array.isArray(playlistAndScheduler) &&
                    sortData(playlistAndScheduler, playlistSortConfig).map((playlist, index) => {
                      return (
                        <TableRow key={playlist.id}>
                          <TableCell>#{++index}</TableCell>
                          <TableCell>{playlist.name}</TableCell>
                          <TableCell>{playlistActions(playlist.id, playlist.name)}</TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
            <TableContainer className="tbl_wraper result_playlist" component={Paper}>
              <Table className={classes.table} stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <TableCell className="table_font">Result</TableCell>
                    <TableCell
                      onClick={() => handleSort('name', scheduleSortConfig, setScheduleSortConfig)}
                      style={{ cursor: 'pointer', userSelect: 'none' }}
                    >
                      Playlist<SortIndicator sortConfig={scheduleSortConfig} columnKey="name" />
                    </TableCell>
                    <TableCell>Days</TableCell>
                    <TableCell
                      onClick={() => handleSort('time', scheduleSortConfig, setScheduleSortConfig)}
                      style={{ cursor: 'pointer', userSelect: 'none' }}
                    >
                      Time<SortIndicator sortConfig={scheduleSortConfig} columnKey="time" />
                    </TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Array.isArray(playlistAndScheduler) &&
                    sortData(getSchedulesFromPlaylist(playlistAndScheduler), scheduleSortConfig).map((playlist, index) => (
                      <TableRow key={index}>
                        <TableCell style={{ fontWeight: 'bold' }}>#{++index}</TableCell>
                        <TableCell>{playlist.name || 'N/A'}</TableCell>
                        <TableCell>{getShortNamesOfWeekDays(playlist.days)}</TableCell>
                        <TableCell>{playlist.time}</TableCell>
                        <TableCell>{playlistActions(playlist.playlistId, playlist.name, true)}</TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
      </div>
      {!!editingPlaylist && <Popup open={!!editingPlaylist} onClose={() => setEditingPlaylist(null)} dialogClassName="edit-playlist-dialog-main">
        <EditPlaylistSecondery
          {...props}
          isPageOpenedAsPopup={true}
          selectedPlaylistForPopup={editingPlaylist}
          onSavePlaylist={() => { setEditingPlaylist(null); refreshCustomerPlaylists(); }}
          isPlaylistRoyalty={editingPlaylist.type === 3}
        />
      </Popup>}
      <PlaylistCopySongsDialog
        playlist={copyDialogPlaylist}
        open={!!copyDialogPlaylist}
        onClose={() => setCopyDialogPlaylist(null)}
        onSuccess={refreshCustomerPlaylists}
      />
    </div>
  );
}

export default CustomerDetails;
